import React from 'react';

import { RequestButton, RequestButtonProps } from '@common/react/components/UI/LoadingButton/LoadingButton';
import { useApplicationContext } from '@common/react/components/Core/Application/Application';
import { WithId } from '@common/typescript/objects/WithId';
import { ModalProps } from '@common/react/components/Modal/ModalContextProvider';
import { getDefaultOptions } from '@common/react/components/UI/Transmutation/defaultOptions';

interface TransmutationBackProps<
	TResponse extends WithId = WithId,
	TRequest extends WithId = TResponse,
	TModalProps = ModalProps,
> extends Omit<RequestButtonProps<TResponse, TRequest, TModalProps>, 'requestType' | 'children'> {
	requestType?: string;
	children?: React.ReactNode;
	wrapper?: (children: React.ReactNode) => React.ReactNode;
}

const TransmutationBack: <TResponse extends WithId = WithId, TRequest extends WithId = TResponse, TModalProps = ModalProps>(
	props: TransmutationBackProps<TResponse, TRequest, TModalProps>,
) => React.ReactElement = <TResponse extends WithId = WithId, TRequest extends WithId = TResponse, TModalProps = ModalProps>(
	props: TransmutationBackProps<TResponse, TRequest, TModalProps>,
) => {
	const {
		wrapper = (children) => children,
		title = 'Login back',
		children = <i className="fa fa-arrow-left" title={title} />,
		...rest
	} = props;

	const defaultProps = {
		...getDefaultOptions<TRequest>(),
		title,
	};

	const { getTransmutationFlag } = useApplicationContext();
	const transmuted = getTransmutationFlag();

	return <>
		{transmuted && wrapper(<RequestButton<TResponse, TRequest, TModalProps>
			{...defaultProps}
			{...rest}
		>
			{children}
		</RequestButton>)}
	</>;
};

export default TransmutationBack;
